<template>
  <div class="banner">
    <div class="mm"></div>
    <div class="banner-img">
      <img src="https://img0.baidu.com/it/u=3818555252,3433824264&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=800" />
    </div>
    <div class="banner-title">
      <p>{{title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 300px;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 100%;

    padding: 10px;
    margin: -10px;
    filter: blur(8px);

    background-image: url(https://img0.baidu.com/it/u=3818555252,3433824264&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=800);
    background-position: center;
    background-size: 100%;
  }

  img {
    position: absolute;
    width: 600px;
    height: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 45px;
    font-weight: 400;
    line-height: 300px;
    text-align: center;
    width: 100%;
  }
}
</style>